import { render, staticRenderFns } from "./ParametrosSistema.vue?vue&type=template&id=1e9d2e62&"
import script from "./ParametrosSistema.vue?vue&type=script&lang=ts&"
export * from "./ParametrosSistema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1e9d2e62', component.options)
    } else {
      api.reload('1e9d2e62', component.options)
    }
    module.hot.accept("./ParametrosSistema.vue?vue&type=template&id=1e9d2e62&", function () {
      api.rerender('1e9d2e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administracion/ParametrosSistema.vue"
export default component.exports